module.exports = __webpack_public_path__ + "static/img/zhaoyouting.ee470c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/zhaoyouting.png
// module id = Sf0C
// module chunks = 1